import { BrowserRouter, Route, Routes } from "react-router";
import "./App.css";
import { setDefaultOptions } from "date-fns";
import { id } from "date-fns/locale";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./hooks/useAuth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import MainLayout from "./layout/MainLayout";
import LoginPage from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import TestimonyIndex from "./pages/Testimony/Index";
import TestimonyForm from "./pages/Testimony/Form";
import FAQIndex from "./pages/FAQ/Index";
import FAQForm from "./pages/FAQ/Form";
import UserIndex from "./pages/User/Index";
import UserForm from "./pages/User/Form";
import HistoryLogIndex from "./pages/HistoryLog/Index";
import HistoryLogForm from "./pages/HistoryLog/Form";
import TrainingCatalogDetail from "./pages/TrainingCatalog/TrainingCatalogDetail";
import TrainingCatalogIndex from "./pages/TrainingCatalog/TrainingCatalogIndex";
import AnnouncementIndex from "./pages/Announcement/Index";
import HelpCenterIndex from "./pages/HelpCenter/Index";
import AnnouncementForm from "./pages/Announcement/Form";
import TrainingVerificationIndex from "./pages/TrainingVerification/Index";
import TrainingVerificationDetail from "./pages/TrainingVerification/Detail";
import VocationalInstitutionForm from "./pages/VocationalInstitution/Form";
import VocationalInstituteIndex from "./pages/VocationalInstitution/Index";
import SectorIndex from "./pages/MasterData/Sector/Index";
import SectorForm from "./pages/MasterData/Sector/Form";
import ISCOIndex from "./pages/MasterData/ISCO/Index";
import ISCOForm from "./pages/MasterData/ISCO/Form";
import PositionIndex from "./pages/MasterData/Position/Index";
import PositionForm from "./pages/MasterData/Position/Form";
import AccessIndex from "./pages/Setting/Access/Index";
import AccessForm from "./pages/Setting/Access/Form";
import InstitutioanlTypeIndex from "./pages/MasterData/InstitutionalType/Index";
import InstitutioanlTypeForm from "./pages/MasterData/InstitutionalType/Form";
import Profile from "./pages/Profile";
import InstitutionalVerificationIndex from "./pages/InstitutionalVerification/Index";
import SMKMajorIndex from "./pages/MasterData/SMKMajor/Index";
import SMKMajorForm from "./pages/MasterData/SMKMajor/Form";
import InstitutionalVerificationDetail from "./pages/InstitutionalVerification/Detail";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import CreateNewPassword from "./pages/ForgotPassword/CreateNewPassword";
import InstitutionalVerificationProgramDetail from "./pages/InstitutionalVerification/Program/Detail";
import ProgramStudyIndex from "./pages/MasterData/ProgramStudy/Index";
import ProgramStudyForm from "./pages/MasterData/ProgramStudy/Form";
import EducationLevelIndex from "./pages/MasterData/EducationLevel/Index";
import EducationLevelForm from "./pages/MasterData/EducationLevel/Form";
import RoleProtectedRoute from "./components/RoleProtectedRoute";
import ParticipantsDetail from "./pages/TrainingCatalog/Participants/Detail";
import VocationalInstitutionOwnershipIndex from "./pages/MasterData/VocationalInstitutionOwnership/Index";
import VocationalInstitutionOwnershipForm from "./pages/MasterData/VocationalInstitutionOwnership/Form";
import GoverningMinistryIndex from "./pages/MasterData/GoverningMinistry/Index";
import GoverningMinistryForm from "./pages/MasterData/GoverningMinistry/Form";
import MigranCenterIndex from "./pages/InstitutionalVerification/MigranCenter/Index";
import MinistryVocationalInstitutionIndex from "./pages/InstitutionalVerification/MinistryVocationalInstitution/Index";
import InstitutionalAffiliationIndex from "./pages/MasterData/InstitutionalAffiliation/Index";
import InstitutionalAffiliationForm from "./pages/MasterData/InstitutionalAffiliation/Form";

setDefaultOptions({ locale: id });
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/create-new-password"
            element={<CreateNewPassword />}
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                {/* <RoleProtectedRoute> */}
                  <MainLayout />
                {/* </RoleProtectedRoute> */}
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />

            <Route path="profile" element={<Profile />} />

            <Route path="training-catalog">
              <Route path="pending">
                <Route
                  index
                  element={<TrainingCatalogIndex type="pending" />}
                />
                <Route
                  path="detail/:id"
                  element={
                    <TrainingCatalogDetail type="pending" showActions />
                  }
                />
              </Route>
              <Route path="accepted">
                <Route
                  index
                  element={
                    <TrainingCatalogIndex
                      type="accepted"
                      detailRoute="/training-catalog/accepted/detail"
                    />
                  }
                />
                <Route
                  path="detail/:id"
                  element={
                    <TrainingCatalogDetail type="accepted" showStatus />
                  }
                />
                <Route
                  path="detail/:catalogId/participant/:participantId"
                  element={<ParticipantsDetail />}
                />
              </Route>
              <Route path="rejected">
                <Route
                  index
                  element={
                    <TrainingCatalogIndex
                      type="rejected"
                      detailRoute="/training-catalog/rejected/detail"
                    />
                  }
                />
                <Route
                  path="detail/:id"
                  element={
                    <TrainingCatalogDetail type="rejected" showStatus />
                  }
                />
              </Route>
            </Route>

            <Route path="training-verification">
              <Route index element={<TrainingVerificationIndex />} />
              <Route
                path=":id"
                element={<TrainingVerificationDetail showActions />}
              />
            </Route>

            <Route path="vocational-institution">
              <Route index element={<VocationalInstituteIndex />} />
              <Route path="create" element={<VocationalInstitutionForm />} />
              <Route
                path="detail/:id"
                element={<VocationalInstitutionForm />}
              />
            </Route>

            <Route path="institutional-verification">
              <Route index element={<InstitutionalVerificationIndex />} />
              <Route
                path="detail/:id"
                element={<InstitutionalVerificationDetail />}
              />
              <Route
                path="detail/:institutionId/program/:programId"
                element={<InstitutionalVerificationProgramDetail />}
              />
              <Route
                path="migran-center"
                element={<MigranCenterIndex />}
              />
              <Route
                path="ministry-vocational-institution"
                element={<MinistryVocationalInstitutionIndex />}
              />
            </Route>
            <Route path="migran-center" element={<MigranCenterIndex />} />
            <Route
              path="ministry-vocational-institution"
              element={<MinistryVocationalInstitutionIndex />}
            />

            <Route path="testimony">
              <Route index element={<TestimonyIndex />} />
              <Route path="create" element={<TestimonyForm />} />
              <Route path="detail/:id" element={<TestimonyForm />} />
            </Route>

            <Route path="faq">
              <Route index element={<FAQIndex />} />
              <Route path="create" element={<FAQForm />} />
              <Route path="detail/:id" element={<FAQForm />} />
            </Route>

            <Route path="help-center" element={<HelpCenterIndex />} />

            <Route path="announcement">
              <Route index element={<AnnouncementIndex />} />
              <Route path="create" element={<AnnouncementForm />} />
              <Route path="detail/:id" element={<AnnouncementForm />} />
            </Route>

            <Route path="user">
              <Route index element={<UserIndex />} />
              <Route path="create" element={<UserForm />} />
              <Route path="detail/:id" element={<UserForm />} />
            </Route>

            <Route path="master-data">
              <Route path="institutional-type">
                <Route index element={<InstitutioanlTypeIndex />} />
                <Route path="create" element={<InstitutioanlTypeForm />} />
                <Route
                  path="detail/:id"
                  element={<InstitutioanlTypeForm />}
                />
              </Route>
              <Route path="vocational-institution-ownership">
                <Route
                  index
                  element={<VocationalInstitutionOwnershipIndex />}
                />
                <Route
                  path="create"
                  element={<VocationalInstitutionOwnershipForm />}
                />
                <Route
                  path="detail/:id"
                  element={<VocationalInstitutionOwnershipForm />}
                />
              </Route>
              <Route path="smk-major">
                <Route index element={<SMKMajorIndex />} />
                <Route path="create" element={<SMKMajorForm />} />
                <Route path="detail/:id" element={<SMKMajorForm />} />
              </Route>
              <Route path="education-level">
                <Route index element={<EducationLevelIndex />} />
                <Route path="create" element={<EducationLevelForm />} />
                <Route path="detail/:id" element={<EducationLevelForm />} />
              </Route>
              <Route path="program-study">
                <Route index element={<ProgramStudyIndex />} />
                <Route path="create" element={<ProgramStudyForm />} />
                <Route path="detail/:id" element={<ProgramStudyForm />} />
              </Route>
              <Route path="sector">
                <Route index element={<SectorIndex />} />
                <Route path="create" element={<SectorForm />} />
                <Route path="detail/:id" element={<SectorForm />} />
              </Route>
              <Route path="isco">
                <Route index element={<ISCOIndex />} />
                <Route path="create" element={<ISCOForm />} />
                <Route path="detail/:id" element={<ISCOForm />} />
              </Route>
              <Route path="position">
                <Route index element={<PositionIndex />} />
                <Route path="create" element={<PositionForm />} />
                <Route path="detail/:id" element={<PositionForm />} />
              </Route>
              <Route path="governing-ministry">
                <Route index element={<GoverningMinistryIndex />} />
                <Route path="create" element={<GoverningMinistryForm />} />
                <Route path="detail/:id" element={<GoverningMinistryForm />} />
              </Route>
              <Route path="institutional-affiliation">
                <Route index element={<InstitutionalAffiliationIndex />} />
                <Route
                  path="create"
                  element={<InstitutionalAffiliationForm />}
                />
                <Route
                  path="detail/:id"
                  element={<InstitutionalAffiliationForm />}
                />
              </Route>
            </Route>

            <Route path="setting">
              <Route path="access">
                <Route index element={<AccessIndex />} />
                <Route path="create" element={<AccessForm />} />
                <Route path="detail/:id" element={<AccessForm />} />
              </Route>
            </Route>

            <Route path="history-log">
              <Route index element={<HistoryLogIndex />} />
              <Route path="detail/:id" element={<HistoryLogForm />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
